import classNames from 'classnames/bind';
import React from 'react';
import styles from './FloatingActionButton.scss';
import { IconButton } from 'mini-fluent-svg-icons/lib/components/IconButton';
import { isIOS } from 'mini-device-utils/lib/utils/isIOS';

export interface FloatingActionButtonProps {
    icon: string;
    onClick: () => void;
    ariaLabel?: string;
    ariaHasPopup?: boolean;
    isDisabled?: boolean;
    iconStyles?: string;
}

export const FloatingActionButton = React.forwardRef(
    (props: FloatingActionButtonProps, ref?: React.RefObject<HTMLDivElement>) => {
        const { icon, ariaLabel, ariaHasPopup, iconStyles, onClick } = props;

        return (
            <div
                className={classNames(
                    styles.floatingActionButtonContainer,
                    isIOS() && styles.iOSSafeAreaContainer
                )}>
                <IconButton
                    icon={icon}
                    className={styles.floatingActionButton}
                    ref={ref}
                    onClick={onClick}
                    role={'button'}
                    aria-label={ariaLabel}
                    aria-haspopup={!!ariaHasPopup}
                    tabIndex={0}
                    iconContainerStyles={iconStyles}
                    primary
                />
            </div>
        );
    }
);
